import { DataBean } from "../DataBean";

export class RequestCreditInfo extends DataBean {
  public async getRequestCreditInfoCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "java.util.List_getRequestCreditInfoCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getRequestCreditInfoRender(
    page: number,
    rows: number,
    properties: any
  ): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.advantage.shared.Report_getRequestCreditInfoRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteRequestCreditInfo(
    idrequestcreditinfo: number
  ): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "boolean_deleteRequestCreditInfo_Number",
      [idrequestcreditinfo]
    );
  }

  public async updateRequestCreditInfo(bean: any): Promise<any> {
    return this.getCustomService(
      "CreditCore",
      "com.credit.bean.RequestCreditInfo_updateRequestCreditInfo_com.credit.bean.RequestCreditInfo",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.credit.bean.RequestCreditInfo",
        },
      ]
    );
  }

  
}
